"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPositionStyles = void 0;
var getPositionStyles = function (position) {
    var styles = {
        left: {
            lightBox: { top: "-2rem", left: "-31.5rem" },
            arrow: { top: ".7rem", left: "-2rem", transform: "rotate(45deg)" },
        },
        bottom: {
            lightBox: { top: "4.5rem", left: "-2rem" },
            arrow: { top: "3.9rem", left: "6rem", transform: "rotate(-45deg)" },
        },
    };
    return styles[position];
};
exports.getPositionStyles = getPositionStyles;
